module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71718/img/blog-post-zero.png"